"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultGlmVersion3 = void 0;
var _defaultGlmContext = require("./defaultGlmContext");
var DefaultGlmVersion3 = exports.DefaultGlmVersion3 = {
  glm: {
    version: 3,
    basicOwnerDetails: _defaultGlmContext.defaultAboutOwner,
    fullOwnerDetails: _defaultGlmContext.defaultAboutOwner
  }
};